exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-well{margin:0 auto;width:100%;height:100%}.list-word-table-header{height:25px}.list-word-table-body{height:calc(100% - 25px);overflow:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--3-1!../node_modules/postcss-loader/lib!../node_modules/sass-loader/lib/loader.js!./assets/scss/WordListWithButtons.scss
// module id = 714
// module chunks = 0